import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetInvoiceChiftSendAttemptsController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceChiftSendAttemptsController.php
* @route '/api/invoicing/{invoice}/chift-send-attempts'
*/
const GetInvoiceChiftSendAttemptsController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceChiftSendAttemptsController.url(args, options),
    method: 'get',
})

GetInvoiceChiftSendAttemptsController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/chift-send-attempts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceChiftSendAttemptsController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceChiftSendAttemptsController.php
* @route '/api/invoicing/{invoice}/chift-send-attempts'
*/
GetInvoiceChiftSendAttemptsController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetInvoiceChiftSendAttemptsController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceChiftSendAttemptsController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceChiftSendAttemptsController.php
* @route '/api/invoicing/{invoice}/chift-send-attempts'
*/
GetInvoiceChiftSendAttemptsController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceChiftSendAttemptsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceChiftSendAttemptsController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceChiftSendAttemptsController.php
* @route '/api/invoicing/{invoice}/chift-send-attempts'
*/
GetInvoiceChiftSendAttemptsController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoiceChiftSendAttemptsController.url(args, options),
    method: 'head',
})

export default GetInvoiceChiftSendAttemptsController